import { appSettingsAppGroupIdQuietHoursRulesData } from "../appSettingsAppGroupIdQuietHoursRulesData";
import type { AllRouteEndpoints } from "../routeTypes";

export const appSettingsAppGroupIdQuietHoursRulesCacheKeys: AllRouteEndpoints[] = [
  appSettingsAppGroupIdQuietHoursRulesData,
];
